import { Pipe, PipeTransform } from '@angular/core';
import { WindowRef } from '../providers/window-ref';

@Pipe({ name: 'headingTagsStrip' })
export class HeadingTagsStripPipe implements PipeTransform {
    constructor(private winRef: WindowRef) {
    }

    transform(value, args?: any[]): any {
        let tagsToRemove = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
        tagsToRemove.forEach((tag) => {
            value = this.winRef.nativeWindow.jQuery('<div />').html(value).find(tag).contents().unwrap().end().end().html();
        });

        return value;
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/heading-tags-strip.pipes.ts